export const POST_SIGN_IN_REDIRECT_URL = '/post-deal/dashboard/';
export const ROUTE = '/accounts/auth';
